module.exports = __webpack_public_path__ + "static/media/soehne-web-kraftig.01e3c7f7.woff2";